<ins-insurance-start-date-data [purchasedProduct]="purchasedProduct"></ins-insurance-start-date-data>
